var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgShareReport(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "20px",
    viewBox: "0 0 18 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1134.000000, -1721.000000)",
    fill: "currentColor",
    id: "Icon/ShareReport"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1132.000000, 1721.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.5 18q-1.042 0-1.771-.729Q12 16.542 12 15.5q0-.167.021-.302.021-.136.062-.302l-4.958-3.021q-.313.333-.74.479-.427.146-.885.146-1.042 0-1.771-.729Q3 11.042 3 10q0-1.042.729-1.771Q4.458 7.5 5.5 7.5q.458 0 .885.156t.74.469l4.958-3.021q-.041-.166-.062-.302Q12 4.667 12 4.5q0-1.042.729-1.771Q13.458 2 14.5 2q1.042 0 1.771.729Q17 3.458 17 4.5q0 1.042-.729 1.771Q15.542 7 14.5 7q-.458 0-.885-.146t-.74-.479L7.917 9.396q.041.166.062.302Q8 9.833 8 10q0 .167-.021.302-.021.136-.062.302l4.958 3.021q.313-.354.74-.49.427-.135.885-.135 1.042 0 1.771.729.729.729.729 1.771 0 1.042-.729 1.771Q15.542 18 14.5 18Z",
    id: "Share"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareReport);
export default __webpack_public_path__ + "static/media/ShareReport.c162167727c7f946604cba296b622b1b.svg";
export { ForwardRef as ReactComponent };